import { render, staticRenderFns } from "./WhatsNewReleaseDrawer.vue?vue&type=template&id=f66451a0&scoped=true"
import script from "./WhatsNewReleaseDrawer.vue?vue&type=script&lang=js"
export * from "./WhatsNewReleaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewReleaseDrawer.vue?vue&type=style&index=0&id=f66451a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66451a0",
  null
  
)

export default component.exports